import pathOr from 'ramda/src/pathOr'
import path from 'ramda/src/path'
import is from 'ramda/src/is'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

export default (state, props) => {
	const { moduleKey, fieldDescPath } = props
	const field = path([moduleIdFromKey(moduleKey), ...fieldDescPath], moduleDescriptions)
	const fieldObj = is(Function, field) ? field(state, props) : field
	return pathOr(false, ['inputStrength'], fieldObj)
}
